(function () {
  const drawer = document.getElementById('quick-buy-drawer');
  const backdrop = document.getElementById('quick-buy-backdrop');
  if (!drawer || !backdrop) return;

  const bodyEl = drawer.querySelector('[data-qb-body]');
  const priceEl = drawer.querySelector('[data-qb-price]');
  const variantLabelEl = drawer.querySelector('[data-qb-variant-label]');
  const addBtn = drawer.querySelector('[data-qb-add]');
  const statusEl = drawer.querySelector('[data-qb-status]');
  const closeBtn = drawer.querySelector('.qb-close');
  const footerEl = drawer.querySelector('[data-qb-footer]');
  const ymalContainerSelector = '[data-ymal-container]';
  const ymalBodySelector = '[data-ymal-body]';

  let currentProduct = null;
  let currentVariant = null;
  let lastCart = null;
  let ymalRenderToken = 0;
  let ymalRetryTimer = null;
  let ajaxCartLoading = false;
  let openFromRightNext = false;
  let ymalRenderAfterLoad = false; // render YMAL after ajaxCart.load completes
  let hideTimer = null;

  const productMetaCache = (window.quickBuyMetaCache = window.quickBuyMetaCache || {});
  const productDataCache = {};

  const moneyFormat = window.theme?.strings?.moneyFormat || window.Shopify?.money_format || '${{amount}}';
  const routesRoot = window.Shopify?.routes?.root || '/';
  const buildRouteUrl = (path) => `${routesRoot}${String(path || '').replace(/^\//, '')}`;
  let cartRefreshTimeout = null;
  const debugYmalSource = true; // Toggle to show/hide source product labels on recommendations (debug use only)

  function resetYmalContainer() {
    const container = document.querySelector(ymalContainerSelector);
    const body = container?.querySelector(ymalBodySelector);
    if (container && body) {
      container.dataset.ymalRendered = 'false';
      body.innerHTML = '';
      container.hidden = true;
    }
  }

  function openMinicartDrawer() {
    const isOpen =
      document.documentElement.classList.contains('js-drawer-open-right') ||
      document.documentElement.classList.contains('js-drawer-open');
    if (isOpen) return;
    const openBtn = document.querySelector('.js-drawer-open-button-right');
    if (openBtn) {
      openBtn.dispatchEvent(new Event('click', { bubbles: true }));
    }
  }

  function buildCartTemplateData(cart) {
    if (!cart || !cart.items) return cart;

    const format = (value) => formatMoney(value);

    const items = cart.items.map((item, idx) => {
      const discounts = (item.line_level_discount_allocations || []).map((d) => ({
        amount: d.amount,
        formattedAmount: format(d.amount * 100),
        discount_application: { title: d.title || d.discount_application?.title || '' },
      }));

      const unitPrice =
        item.unit_price && item.unit_price_measurement
          ? {
              price: format(item.unit_price * 100),
              reference_unit: item.unit_price_measurement.reference_unit,
              reference_value: item.unit_price_measurement.reference_value,
              addRefererenceValue: true,
            }
          : null;

      return {
        line: idx + 1,
        url: item.url,
        img: item.image,
        name: item.product_title,
        vendor: item.vendor,
        price: format(item.original_line_price),
        discountedPrice: format(item.final_line_price),
        discountsApplied: item.line_level_discount_allocations?.length > 0 || item.total_discount > 0,
        discounts,
        itemAdd: item.quantity + 1,
        itemMinus: Math.max(item.quantity - 1, 0),
        itemQty: item.quantity,
        key: item.key,
        product_has_only_default_variant:
          item.product_has_only_default_variant !== undefined
            ? item.product_has_only_default_variant
            : item.variant_title === 'Default Title',
        variant_options: (item.options_with_values || []).map((opt) => ({ name: opt.name, value: opt.value })),
        properties: item.properties,
        unitPrice,
      };
    });

    const cartDiscounts = (cart.cart_level_discount_applications || []).map((d) => ({
      title: d.title,
      formattedAmount: format(d.total_allocated_amount),
    }));

    return {
      ...cart,
      items,
      totalPrice: format(cart.total_price),
      cartDiscounts,
      cartDiscountsApplied: cartDiscounts.length > 0,
    };
  }

  function renderCartTemplate(cart) {
    const templateEl = document.getElementById('CartTemplate');
    const container = document.getElementById('CartContainer');
    if (!templateEl || !container || !window.Handlebars) return;
    try {
      const template = window.Handlebars.compile(templateEl.innerHTML);
      const html = template(buildCartTemplateData(cart) || {});
      container.innerHTML = html;
    } catch (e) {
      console.error('[QuickBuy] renderCartTemplate error', e);
    }
  }

  function refreshMinicartHtml() {
    if (ajaxCartLoading) return;
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      ajaxCartLoading = true;
      try {
        // resetYmalContainer();
        window.ajaxCart.load();
      } finally {
        ajaxCartLoading = false;
      }
    } else if (lastCart) {
      renderCartTemplate(lastCart);
    }
  }

  function refreshCartUI(triggerSource, { skipAjaxCartReload = false } = {}) {
    fetch(`${buildRouteUrl('cart.js')}?presentation=localized`)
      .then((res) => res.json())
      .then((cart) => {
        lastCart = cart;
        const ajaxCartAvailable = window.ajaxCart && typeof window.ajaxCart.load === 'function';
        const ymalContainer = document.querySelector(ymalContainerSelector);
        const needsAjaxCartReload =
          ajaxCartAvailable && !skipAjaxCartReload && (!ymalContainer || ymalContainer.dataset.ymalRendered !== 'true');
        // Update cart bubbles
        document.querySelectorAll('.cart-link__bubble').forEach((el) => {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });

        // Sync quantities in the open minicart if present
        const qtyInputsAll = Array.from(document.querySelectorAll('.ajaxcart__qty-num'));
        if (qtyInputsAll.length) {
          cart.items.forEach((item, idx) => {
            // Prefer matching by key if available
            const matches = qtyInputsAll.filter((input) => input.dataset.id === item.key);
            const inputsForItem = matches.length ? matches : [qtyInputsAll[idx]].filter(Boolean);

            inputsForItem.forEach((input) => {
              input.value = item.quantity;
              input.dataset.id = item.key;
              input.setAttribute('data-line', idx + 1);
              const plus = input.parentElement?.querySelector('.ajaxcart__qty--plus');
              const minus = input.parentElement?.querySelector('.ajaxcart__qty--minus');
              if (plus) plus.setAttribute('data-line', idx + 1);
              if (minus) minus.setAttribute('data-line', idx + 1);
            });
          });
        }

        if (needsAjaxCartReload) {
          // Ensure minicart HTML (including YMAL slot) is present before rendering recommendations
          ymalRenderAfterLoad = true;
          refreshMinicartHtml();
        }

        renderMinicartRecommendations(cart);
        if (!skipAjaxCartReload && !ajaxCartAvailable) {
          refreshMinicartHtml();
        }

        // Broadcast cart updated for any listeners
        const evt = new CustomEvent('cart:updated', { detail: { cart, source: triggerSource } });
        document.dispatchEvent(evt);
        if (typeof window.dispatchEvent === 'function') {
          window.dispatchEvent(evt);
        }
      })
      .catch(() => {});
  }

  // allow custom delay
  function scheduleCartRefresh(reason, delay = 250) {
    clearTimeout(cartRefreshTimeout);
    cartRefreshTimeout = setTimeout(() => refreshCartUI(reason), delay);
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    
    const formatString = moneyFormat || '${{amount}}';
    const placeholder = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
    const formatType = placeholder ? placeholder[1] : 'amount';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) return '0';
      const fixed = (number / 100).toFixed(precision);
      const parts = fixed.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    let value;
    switch (formatType) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholder ? placeholder[0] : '{{amount}}', value);
  }

  function getProductUrl(product) {
    if (!product) return '#';
    if (product.url) return product.url;
    if (product.online_store_url) return product.online_store_url;
    if (product.handle) return `/products/${product.handle}`;
    return '#';
  }

  function setStatus(msg, isError = false) {
    statusEl.textContent = msg || '';
    statusEl.classList.toggle('qb-status--error', !!isError);
  }

  function openDrawer(fromRight = false) {
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    drawer.hidden = false;
    backdrop.hidden = false;
    const slideFromRight = fromRight || openFromRightNext;
    openFromRightNext = false;
    drawer.dataset.fromRight = slideFromRight ? 'true' : '';
    drawer.classList.toggle('qb-drawer--from-right', !!slideFromRight);
    // document.body.classList.add('qb-open');
    document.documentElement.classList.add('qb-open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    // document.body.classList.remove('qb-open');
    document.documentElement.classList.remove('qb-open');
    if (drawer.dataset.fromRight === 'true') {
      drawer.classList.add('qb-drawer--from-right');
    } else {
      drawer.classList.remove('qb-drawer--from-right');
    }
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('aria-hidden', 'true');
    setStatus('');
    hideTimer = setTimeout(() => {
      drawer.hidden = true;
      backdrop.hidden = true;
    }, 300);
  }

  function setLoading() {
    bodyEl.innerHTML = '<div class="qb-loading">Loading…</div>';
    footerEl.hidden = true;
    setStatus('');
  }

  function findHandle(el) {
    if (!el) return null;
    const handleAttr =
      el.dataset.productHandle ||
      el.dataset.handle ||
      el.dataset.productUrl ||
      el.getAttribute('data-product-handle') ||
      el.getAttribute('data-handle');
    if (handleAttr && handleAttr.includes('/products/')) {
      const m = handleAttr.match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    if (handleAttr && !handleAttr.includes('/')) return handleAttr;

    const link = el.closest('a[href*="/products/"]');
    if (link && link.href) {
      const m = link.href.match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return null;
  }

  function normalizeHandle(handle) {
    if (!handle) return null;
    if (typeof handle === 'object' && handle.handle) return handle.handle;
    const str = String(handle).trim();
    if (!str) return null;
    const match = str.match(/\/products\/([^/?#]+)/);
    if (match) return match[1];
    return str;
  }

  function extractYmalHandles(meta) {
    const handles = [];
    if (!meta) return handles;
    const pools = [];
    if (Array.isArray(meta.ymal_handles)) pools.push(meta.ymal_handles);
    if (Array.isArray(meta.ymal_products)) pools.push(meta.ymal_products);
    if (Array.isArray(meta)) pools.push(meta);

    pools.forEach((arr) => {
      arr.forEach((entry) => {
        const normalized = normalizeHandle(entry?.handle || entry);
        if (normalized) handles.push(normalized);
      });
    });
    return Array.from(new Set(handles.filter(Boolean)));
  }

  function fetchProductMeta(handle) {
    const normalized = normalizeHandle(handle);
    if (!normalized) return Promise.resolve(null);
    if (productMetaCache[normalized]) return Promise.resolve(productMetaCache[normalized]);

    // return fetch(`/products/${normalized}?view=qb-meta`)
    return fetch(buildRouteUrl(`products/${normalized}?view=qb-meta`))
      .then((res) => (res.ok ? res.text() : null))
      .then((text) => {
        if (!text) return null;
        let parsed = null;
        try {
          parsed = JSON.parse(text);
        } catch (e) {
          const match = text.match(/\{[\s\S]*\}/);
          if (match) {
            try {
              parsed = JSON.parse(match[0]);
            } catch (e2) {
              parsed = null;
            }
          }
        }
        const result = parsed || text.trim();
        productMetaCache[normalized] = result;
        return result;
      })
      .catch(() => null);
  }

  function fetchProductData(handle) {
    const normalized = normalizeHandle(handle);
    if (!normalized) return Promise.resolve(null);
    if (productDataCache[normalized]) return Promise.resolve(productDataCache[normalized]);

    // return fetch(`/products/${normalized}.js`)
    return fetch(buildRouteUrl(`products/${normalized}.js`))
      .then((res) => (res.ok ? res.json() : null))
      .then((product) => {
        productDataCache[normalized] = product;
        return product;
      })
      .catch(() => null);
  }

  function renderOptions(product) {
    const wrapper = document.createElement('div');
    wrapper.className = 'qb-options';

    product.options.forEach((opt, idx) => {
      const optDiv = document.createElement('div');
      optDiv.className = 'qb-option';
      const label = document.createElement('label');
      label.textContent = opt.name + ' :';
      label.setAttribute('data-option-index', idx);

      const valuesDiv = document.createElement('div');
      valuesDiv.className = 'qb-option-values';
      valuesDiv.dataset.optionIndex = idx;

      opt.values.forEach((val) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'qb-option-btn';
        btn.textContent = val;
        btn.dataset.value = val;
        btn.addEventListener('click', () => {
          valuesDiv.querySelectorAll('.qb-option-btn').forEach((b) => b.classList.remove('active'));
          btn.classList.add('active');
          handleVariantChange();
        });
        valuesDiv.appendChild(btn);
      });

      optDiv.appendChild(label);
      optDiv.appendChild(valuesDiv);
      wrapper.appendChild(optDiv);
    });

    return wrapper;
  }

  function handleVariantChange() {
    if (!currentProduct) return;
    const selectedOptions = getSelectedOptions();

    const matched = currentProduct.variants.find(
      (v) => v.options.length === selectedOptions.length && v.options.every((val, idx) => val === selectedOptions[idx])
    );
    if (matched) {
      currentVariant = matched;
      updatePriceAndLabel();
    }
    updateOptionAvailability();
  }

  function getSelectedOptions() {
    const buttonGroups = drawer.querySelectorAll('.qb-option-values');
    if (buttonGroups.length) {
      return Array.from(buttonGroups).map((group) => {
        const active = group.querySelector('.qb-option-btn.active') || group.querySelector('.qb-option-btn');
        return active ? active.dataset.value : '';
      });
    }

    const selects = drawer.querySelectorAll('.qb-option select');
    return Array.from(selects).map((sel) => sel.value);
  }

  function updateOptionAvailability() {
    if (!currentProduct) return;
    const selectedOptions = getSelectedOptions();
    const groups = drawer.querySelectorAll('.qb-option-values');
    groups.forEach((group, optIdx) => {
      group.querySelectorAll('.qb-option-btn').forEach((btn) => {
        const candidate = [...selectedOptions];
        candidate[optIdx] = btn.dataset.value;
        const availableVariant = currentProduct.variants.find(
          (v) => v.available && v.options.every((val, idx) => val === candidate[idx])
        );
        const isAvailable = !!availableVariant;
        btn.classList.toggle('qb-option-btn--unavailable', !isAvailable);
        btn.disabled = !isAvailable;
      });
    });
  }

  function updatePriceAndLabel() {
    if (!currentVariant) return;
    priceEl.textContent = formatMoney(currentVariant.price);
    variantLabelEl.textContent = currentVariant.title.includes('Default') ? '' : currentVariant.title;
    addBtn.disabled = !currentVariant.available;
    addBtn.textContent = currentVariant.available
      ? window.theme?.strings?.addToCartText || 'Add to cart'
      : window.theme?.strings?.outOfStockText || 'Out of stock';
  }

  function cleanText(html) {
    const div = document.createElement('div');
    div.innerHTML = html || '';
    const text = (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
    return text;
  }

  function getShortDescription(product) {
    const meta = product?.metafields || {};
    const handle = product?.handle;
    const inlineMeta = product?.metaShortDescription;

    // If metafields come as an array, try to find namespace/key
    const arrayMetaValue =
      Array.isArray(meta) &&
      meta.find((m) => m?.namespace === 'pdp' && m?.key === 'short_description')?.value;

    // If Liquid injected a map of metafields, use it
    const injected =
      (window.quickBuyMetafields && (window.quickBuyMetafields[handle] || window.quickBuyMetafields[product?.id])) ||
      null;

    const candidates = [
      inlineMeta,
      injected,
      arrayMetaValue,
      meta?.pdp?.short_description?.value,
      meta?.pdp?.short_description,
      meta?.short_description?.value,
      meta?.short_description,
      meta?.global?.short_description?.value,
      meta?.global?.short_description,
      product.description,
      product.body_html,
    ];

    for (const entry of candidates) {
      const cleaned = cleanText(entry);
      if (cleaned) return cleaned;
    }
    return '';
  }

  function renderProduct(product) {
    currentProduct = product;
    currentVariant = product.variants.find((v) => v.available) || product.variants[0];

    const productEl = document.createElement('div');
    productEl.className = 'qb-product';

    const gallery = renderGallery(product);
    const info = document.createElement('div');
    info.className = 'qb-product__info';
    const title = document.createElement('a');
    title.className = 'qb-product__title';
    title.href = getProductUrl(product);
    title.textContent = product.title;

    const vendor = document.createElement('p');
    vendor.className = 'qb-product__vendor';
    vendor.textContent = product.vendor || '';

    const desc = document.createElement('div');
    desc.className = 'qb-product__desc product__meta__short-description';
    desc.textContent = truncateDescription(getShortDescription(product), 140);

    const wishlistTemplate = document.getElementById('qb-wishlist-template');
    const wishlist = document.createElement('div');
    wishlist.className = 'qb-wishlist header__right__element wishlist';
    if (wishlistTemplate && wishlistTemplate.content) {
      wishlist.appendChild(wishlistTemplate.content.cloneNode(true));
    }

    info.appendChild(title);
    if (vendor.textContent) info.appendChild(vendor);
    info.appendChild(priceEl);
    info.appendChild(variantLabelEl);
    if (desc.textContent) info.appendChild(desc);
    info.appendChild(wishlist);

    productEl.appendChild(gallery);
    productEl.appendChild(info);

    bodyEl.innerHTML = '';
    bodyEl.appendChild(productEl);

    // Preselect current variant on option buttons
    const buttonGroups = bodyEl.querySelectorAll('.qb-option-values');
    if (currentVariant && buttonGroups.length === currentVariant.options.length) {
      currentVariant.options.forEach((val, idx) => {
        const group = bodyEl.querySelector(`.qb-option-values[data-option-index="${idx}"]`);
        if (group) {
          group.querySelectorAll('.qb-option-btn').forEach((btn) => {
            btn.classList.toggle('active', btn.dataset.value === val);
          });
          if (!group.querySelector('.qb-option-btn.active')) {
            const firstBtn = group.querySelector('.qb-option-btn');
            if (firstBtn) firstBtn.classList.add('active');
          }
        }
      });
    }

    // Move size/options into footer before button
    const footerRight = footerEl.querySelector('.qb-footer__right') || footerEl;
    const existingOptions = footerEl.querySelector('.qb-options');
    if (existingOptions) existingOptions.remove();
    const options = renderOptions(product);
    footerRight.insertBefore(options, addBtn);

    // Ensure option buttons in the footer reflect the current variant
    const footerGroups = footerEl.querySelectorAll('.qb-option-values');
    if (currentVariant && footerGroups.length === currentVariant.options.length) {
      currentVariant.options.forEach((val, idx) => {
        const group = footerEl.querySelector(`.qb-option-values[data-option-index="${idx}"]`);
        if (group) {
          group.querySelectorAll('.qb-option-btn').forEach((btn) => {
            btn.classList.toggle('active', btn.dataset.value === val);
          });
          if (!group.querySelector('.qb-option-btn.active')) {
            const firstBtn = group.querySelector('.qb-option-btn');
            if (firstBtn) firstBtn.classList.add('active');
          }
        }
      });
    }

    updateOptionAvailability();
    updatePriceAndLabel();
    footerEl.hidden = false;
  }

  function truncateDescription(htmlString, maxLen) {
    const text = cleanText(htmlString);
    if (text.length <= maxLen) return text;
    return text.slice(0, maxLen).trim() + '…';
  }

  function renderGallery(product) {
    const gallery = document.createElement('div');
    gallery.className = 'qb-gallery';
    const viewport = document.createElement('div');
    viewport.className = 'embla__viewport';
    const container = document.createElement('div');
    container.className = 'embla__container';

    const images = (product.images && product.images.length ? product.images : [product.featured_image]).filter(Boolean);
    images.forEach((imgUrl, idx) => {
      const slide = document.createElement('div');
      slide.className = 'embla__slide';
      const link = document.createElement('a');
      link.className = 'qb-gallery__link';
      link.href = getProductUrl(product);
      const img = document.createElement('img');
      img.src = imgUrl;
      img.alt = product.title;
      link.appendChild(img);
      slide.appendChild(link);
      container.appendChild(slide);
    });

    viewport.appendChild(container);
    gallery.appendChild(viewport);

    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'embla__button embla__button--prev';
    prevBtn.innerHTML = '&#8249;';

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'embla__button embla__button--next';
    nextBtn.innerHTML = '&#8250;';

    const dots = document.createElement('div');
    dots.className = 'embla__dots';

    gallery.appendChild(prevBtn);
    gallery.appendChild(nextBtn);
    gallery.appendChild(dots);

    if (window.EmblaCarousel) {
      const embla = window.EmblaCarousel(viewport, { loop: images.length > 1 });
      const dotNodes = [];

      function addDots() {
        dots.innerHTML = '';
        embla.scrollSnapList().forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'embla__dot';
          dot.addEventListener('click', () => embla.scrollTo(i));
          dots.appendChild(dot);
          dotNodes.push(dot);
        });
      }

      function setActiveDot() {
        const selected = embla.selectedScrollSnap();
        dotNodes.forEach((dot, i) => {
          dot.classList.toggle('is-selected', i === selected);
        });
      }

      addDots();
      setActiveDot();
      embla.on('select', setActiveDot);

      prevBtn.addEventListener('click', () => embla.scrollPrev());
      nextBtn.addEventListener('click', () => embla.scrollNext());
    } else {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      dots.style.display = 'none';
    }

    return gallery;
  }

  function renderYmalSlider(products, sourceMap = {}, sourceTitleMap = {}) {
    const slider = document.createElement('div');
    slider.className = 'qb-ymal-slider';
    const heading = document.querySelector('.ajaxcart__ymal-title');
    if (heading && !heading.dataset.originalTitle) {
      heading.dataset.originalTitle = heading.textContent || '';
    }

    const viewport = document.createElement('div');
    viewport.className = 'qb-ymal__viewport';
    const container = document.createElement('div');
    container.className = 'qb-ymal__container';

    products.forEach((product) => {
      const slide = document.createElement('div');
      slide.className = 'qb-ymal__slide';

      const imageWrap = document.createElement('div');
      imageWrap.className = 'qb-ymal__image';
      const img = document.createElement('img');
      img.src = product.featured_image || product.images?.[0] || '';
      img.alt = product.title || '';
      imageWrap.appendChild(img);
      imageWrap.addEventListener('mouseenter', () => {
        if (heading) heading.textContent = product.title || heading.dataset.originalTitle || '';
      });
      imageWrap.addEventListener('mouseleave', () => {
        if (heading) heading.textContent = heading.dataset.originalTitle || heading.textContent || '';
      });
      imageWrap.addEventListener('click', (evt) => {
        evt.preventDefault();
        loadProduct(product.handle);
      });

      const info = document.createElement('div');
      info.className = 'qb-ymal__info';
      const title = document.createElement('p');
      title.className = 'qb-ymal__title';
      title.textContent = product.title || '';

      const sources = sourceMap[product.handle] || [];
      if (debugYmalSource && sources.length) {
        const source = document.createElement('p');
        source.className = 'qb-ymal__source';
        const labels = sources.map((h) => sourceTitleMap[h] || h);
        source.textContent = labels.length === 1 ? labels[0] : labels.join(', ');
        info.appendChild(source);
      }

      const price = document.createElement('div');
      price.className = 'qb-ymal__price';
      const primaryVariant = product.variants?.[0];
      price.textContent = primaryVariant ? formatMoney(primaryVariant.price) : '';

      const cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'qb-ymal__button';
      cta.textContent = window.theme?.strings?.viewProduct || 'Quick buy';
      cta.addEventListener('click', (evt) => {
        evt.preventDefault();
        loadProduct(product.handle);
      });

      info.appendChild(title);
      if (price.textContent) info.appendChild(price);
      info.appendChild(cta);

      slide.appendChild(imageWrap);
      slide.appendChild(info);
      container.appendChild(slide);
    });

    viewport.appendChild(container);
    slider.appendChild(viewport);

    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'qb-ymal__nav qb-ymal__nav--prev';
    prevBtn.innerHTML = '&#8249;';

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'qb-ymal__nav qb-ymal__nav--next';
    nextBtn.innerHTML = '&#8250;';

    const dots = document.createElement('div');
    dots.className = 'qb-ymal__dots';

    slider.appendChild(prevBtn);
    slider.appendChild(nextBtn);
    slider.appendChild(dots);

    if (window.EmblaCarousel) {
      const embla = window.EmblaCarousel(viewport, {
        align: 'start',
        loop: true,
        dragFree: true,
        speed: 20,
      });
      const dotNodes = [];

      function addDots() {
        dots.innerHTML = '';
        embla.scrollSnapList().forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'qb-ymal__dot';
          dot.addEventListener('click', () => embla.scrollTo(i));
          dots.appendChild(dot);
          dotNodes.push(dot);
        });
      }

      function setActiveDot() {
        const selected = embla.selectedScrollSnap();
        dotNodes.forEach((dot, i) => dot.classList.toggle('is-selected', i === selected));
      }

      addDots();
      setActiveDot();
      embla.on('select', setActiveDot);

      prevBtn.addEventListener('click', () => embla.scrollPrev());
      nextBtn.addEventListener('click', () => embla.scrollNext());
    } else {
      dots.style.display = 'none';
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      container.style.overflowX = 'auto';
    }

    return slider;
  }

  function renderMinicartRecommendations(cart) {
    const container = document.querySelector(ymalContainerSelector);
    const body = container?.querySelector(ymalBodySelector);
    if (!container || !body) {
      clearTimeout(ymalRetryTimer);
      ymalRetryTimer = setTimeout(() => {
        renderMinicartRecommendations(lastCart || cart);
      }, 120);
      return;
    }

    document.querySelectorAll('.qb-ymal-slider').forEach((el) => el.remove());

    const renderToken = ++ymalRenderToken;
    const isStale = () => renderToken !== ymalRenderToken;

    container.dataset.ymalRendered = 'rendering';

    body.innerHTML = '';
    const oldSlider = body.querySelector('.qb-ymal-slider');
    if (oldSlider) oldSlider.remove(); // <-- add this to prevent doubles
    container.hidden = true;

    if (!cart?.items?.length) {
      container.dataset.ymalRendered = 'false';
      return;
    }

    const cartHandles = Array.from(new Set(cart.items.map((item) => normalizeHandle(item.handle)).filter(Boolean)));
    const cartTitleMap = {};
    cart.items.forEach((item) => {
      const h = normalizeHandle(item.handle);
      if (h) cartTitleMap[h] = item.product_title || item.title || h;
    });
    const metaPromises = cartHandles.map((handle) => fetchProductMeta(handle));

    Promise.all(metaPromises)
      .then((metas) => {
        if (isStale()) return [];
        const relatedHandles = new Set();
        const relatedSourceMap = {};
        metas.forEach((meta, idx) => {
          const sourceHandle = cartHandles[idx];
          extractYmalHandles(meta).forEach((h) => {
            if (!h) return;
            if (!relatedSourceMap[h]) relatedSourceMap[h] = new Set();
            relatedSourceMap[h].add(sourceHandle);
            if (!cartHandles.includes(h)) relatedHandles.add(h);
          });
        });
        const handlesArr = Array.from(relatedHandles);
        const relatedSourceMapArr = Object.fromEntries(
          Object.entries(relatedSourceMap).map(([k, v]) => [k, Array.from(v)])
        );
        if (!handlesArr.length) {
          container.hidden = true;
          return [];
        }
        return Promise.all(handlesArr.map((h) => fetchProductData(h))).then((products) => ({
          products,
          relatedSourceMap: relatedSourceMapArr,
        }));
      })
      .then((payload = { products: [] }) => {
        if (isStale()) return;
        const validProducts = (payload.products || payload).filter(Boolean);
        if (!validProducts.length) {
          container.hidden = true;
          container.dataset.ymalRendered = 'false';
          return;
        }
        body.appendChild(renderYmalSlider(validProducts, payload.relatedSourceMap || {}, cartTitleMap));
        container.hidden = false;
        container.dataset.ymalRendered = 'true';
      })
      .catch(() => {
        container.hidden = true;
        container.dataset.ymalRendered = 'false';
      })
      .finally(() => {
        if (isStale()) return;
      });
  }

  function loadProduct(handle, fromRight = false) {
    openFromRightNext = fromRight;
    setLoading();
    const productPromise = fetchProductData(handle);
    const metaPromise = fetchProductMeta(handle);

    Promise.all([productPromise, metaPromise])
      .then(([product, meta]) => {
        if (!product) throw new Error('Product not found');
        if (meta && typeof meta === 'object' && meta.short_description) {
          product.metaShortDescription = meta.short_description;
        } else if (typeof meta === 'string' && meta) {
          product.metaShortDescription = meta;
        }
        renderProduct(product);
        openDrawer(fromRight);
      })
      .catch((err) => {
        console.error('[QuickBuy] load error', err);
        bodyEl.innerHTML = '<div class="qb-loading">Unable to load product right now.</div>';
        setStatus('Unable to load product right now.', true);
      });
  }

  function doAddToCart() {
    if (!currentVariant) return;
    const quantity = 1;
    addBtn.disabled = true;
    const originalLabel = addBtn.dataset.originalLabel || addBtn.textContent;
    addBtn.dataset.originalLabel = originalLabel;
    addBtn.classList.add('is-loading');
    setStatus('Adding…');

    fetch(buildRouteUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: currentVariant.id,
        quantity,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(() => {
        setStatus('Added to cart!');
        refreshMinicartHtml();
        setTimeout(() => openMinicartDrawer(), 800);
        
        // Broadcast a general cart refresh hook for any listeners
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'quick-buy' } }));
        
        resetYmalContainer();
        refreshCartUI('quick-buy', { skipAjaxCartReload: true });
        ymalRenderAfterLoad = true; // ensure first render happens after the drawer HTML is ready
        setTimeout(closeDrawer, 800);
      })
      .catch((err) => {
        console.error('[QuickBuy] add error', err);
        setStatus('Could not add to cart. Please try again.', true);
      })
      .finally(() => {
        addBtn.disabled = false;
        addBtn.classList.remove('is-loading');
        addBtn.textContent = addBtn.dataset.originalLabel || originalLabel;
      });
  }

  function handleVariantLinkClick(event) {
    if (window.innerWidth < 1024) return;
    const trigger = event.target.closest('a.variant-highlight, a.variant-spotlight');
    if (!trigger) return;
    const handle = findHandle(trigger);
    if (!handle) return;
    event.preventDefault();
    event.stopPropagation();
    loadProduct(handle, true);
    // setTimeout(() => openMinicartDrawer(), 400);
  }

  document.addEventListener('click', handleVariantLinkClick, true);
  function handleCartUpdated(evt) {
    if (evt?.detail?.cart) {
      renderMinicartRecommendations(evt.detail.cart);
    }
  }
  function handleCartRefresh(detail) {
    const skipAjaxCartReload = detail?.source === 'quick-buy' || detail?.skipAjaxCartReload;
    refreshCartUI('cart:refresh', { skipAjaxCartReload });
  }
  document.addEventListener('cart:updated', handleCartUpdated);
  document.addEventListener('cart:refresh', (evt) => handleCartRefresh(evt?.detail));

  function handleExternalProductAdded(evt) {
    // When products are added outside of quick buy (e.g., PDP), ensure YMAL renders after ajaxCart updates.
    ymalRenderAfterLoad = true;
    refreshCartUI(evt?.type || 'external-add', { skipAjaxCartReload: true });
  }
  document.addEventListener('ajaxProduct:added', handleExternalProductAdded);
  document.addEventListener('product:added', handleExternalProductAdded);
  function handleAjaxCartAfterCartLoad() {
    const container = document.querySelector(ymalContainerSelector);
    if (lastCart?.items?.length && container && container.dataset.ymalRendered !== 'true') {
      // Ensure YMAL renders after the ajaxCart markup is fully in the DOM (e.g., PDP adds)
      ymalRenderAfterLoad = true;
    }
    refreshCartUI('ajaxCart.afterCartLoad', { skipAjaxCartReload: true });
    setTimeout(() => {
      if (lastCart && ymalRenderAfterLoad) {
        ymalRenderAfterLoad = false;
        renderMinicartRecommendations(lastCart);
      }
    }, 80); // small delay to ensure DOM is in place
  }
  function handleAjaxCartAfterCartRequest() {
    scheduleCartRefresh('ajaxCart.afterCartRequest');
  }

  document.addEventListener('ajaxCart.afterCartLoad', handleAjaxCartAfterCartLoad);
  document.addEventListener('ajaxCart.afterCartRequest', handleAjaxCartAfterCartRequest);

  function ensureMinicartReady() {
    const cartContainer = document.getElementById('CartContainer');
    if (lastCart && cartContainer && !cartContainer.innerHTML.trim()) {
      renderCartTemplate(lastCart);
    }
    refreshMinicartHtml();
  }

  // Some themes emit ajaxCart events via jQuery only; bridge them to our handlers if jQuery is present
  function bindJqueryAjaxCartEvents() {
    if (!window.jQuery || window.quickBuyJqueryBound) return;
    const $doc = window.jQuery(document);
    window.quickBuyJqueryBound = true;
    $doc.on('ajaxCart.afterCartLoad', handleAjaxCartAfterCartLoad);
    $doc.on('ajaxCart.afterCartRequest', handleAjaxCartAfterCartRequest);
    $doc.on('cart:updated', (evt, detail) => handleCartUpdated({ detail }));
    $doc.on('cart:refresh', (evt, detail) => handleCartRefresh(detail));
  }
  bindJqueryAjaxCartEvents();


  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('.js-drawer-open-button-right');
    if (openBtn) {
      ensureMinicartReady(); // prime minicart content before the drawer slides in
      setTimeout(() => {
        if (lastCart) {
          renderMinicartRecommendations(lastCart);
        } else {
          refreshCartUI('drawer-open');
        }
      }, 50);
    }
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.ajaxcart__qty-adjust, .ajaxcart__qty-remove')) {
      scheduleCartRefresh('minicart-qty');
    }
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('.ajaxcart__qty-num')) {
      scheduleCartRefresh('minicart-qty-input');
    }
  });

  document.addEventListener('click', (event) => {
    const removeBtn = event.target.closest('.ajaxcart__qty-remove');
    if (removeBtn) {
      resetYmalContainer();                // clear old YMAL immediately
      scheduleCartRefresh('minicart-remove', 700); // slower refresh for removal
      return;
    }
    if (event.target.closest('.ajaxcart__qty-adjust')) {
      scheduleCartRefresh('minicart-qty');
    }
  });

  const ymalObserver = new MutationObserver(() => {
    const container = document.querySelector(ymalContainerSelector);
    const body = container?.querySelector(ymalBodySelector);
    if (container && body && (!body.childElementCount || container.dataset.ymalRendered !== 'true')) {
      if (lastCart) {
        renderMinicartRecommendations(lastCart);
      } else {
        refreshCartUI('ymal-observer');
      }
    }
  });
  ymalObserver.observe(document.body, { childList: true, subtree: true });

  addBtn?.addEventListener('click', doAddToCart);
  closeBtn?.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);
  refreshCartUI('init');
})();
